import { render, staticRenderFns } from "./aboutgritify.vue?vue&type=template&id=37aafb10&scoped=true&"
import script from "./aboutgritify.vue?vue&type=script&lang=ts&"
export * from "./aboutgritify.vue?vue&type=script&lang=ts&"
import style0 from "./aboutgritify.vue?vue&type=style&index=0&id=37aafb10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aafb10",
  null
  
)

/* custom blocks */
import block0 from "./aboutgritify.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Cpages%5Caboutgritify.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
